import {
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  input,
  signal,
} from '@angular/core';
import { DuctProperties } from '../../../../span-progress-entities';

@Component({
  selector: 'app-duct-list-popup-content',
  templateUrl: './duct-list-popup-content.component.html',
  styleUrl: './duct-list-popup-content.component.scss',
  standalone: false,
})
export class DuctListPopupContentComponent implements OnInit, OnChanges {
  titleKey = input<string>('');
  nameLabelKey = input<string>('');
  fromToLabelKey = input<string>('');
  rows = input<DuctProperties[]>([]);
  useFromPoint = input<boolean>(true);
  startExpanded = input<boolean>(true);

  isExpanded = signal(false);
  sortedRows = signal<DuctProperties[]>([]);

  ngOnInit(): void {
    this.isExpanded.set(this.startExpanded());
    this.updateSortedRows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rows']) {
      this.isExpanded.set(this.startExpanded());
      this.updateSortedRows();
    }
  }

  toggle(): void {
    this.isExpanded.update((value) => !value);
  }

  private updateSortedRows(): void {
    const sorted = (this.rows() ?? [])
      .slice()
      .sort((a, b) =>
        (b.ductName ?? '')
          .toUpperCase()
          .localeCompare((a.ductName ?? '').toUpperCase()),
      );
    this.sortedRows.set(sorted);
  }
}
